export async function raiseHsePdfRequestError(error) {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const json = JSON.parse(await data.text());
      const message = Array.isArray(json.errors)
        ? json.errors.join(", ")
        : json.message || json.error;
      if (message) throw new Error(message);
    } catch (parsed) {
      if (parsed instanceof Error && parsed.message && !(parsed instanceof SyntaxError)) {
        throw parsed;
      }
    }
  }
  throw error;
}

export async function downloadHsePdfBlob(data, filename) {
  if (data?.type && data.type !== "application/pdf") {
    const text = await data.text();
    try {
      const json = JSON.parse(text);
      throw new Error(json.errors?.[0] || json.message || "Invalid PDF response");
    } catch (error) {
      if (error.message !== "Invalid PDF response") throw error;
      throw new Error("Response is not a PDF file");
    }
  }

  const arrayBuffer = data instanceof Blob ? await data.arrayBuffer() : data;
  const uint8Array = new Uint8Array(arrayBuffer);
  const pdfHeader = String.fromCharCode(...uint8Array.slice(0, 4));
  if (pdfHeader !== "%PDF") {
    throw new Error("Invalid PDF file");
  }

  const blob = new Blob([arrayBuffer], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
